/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_GoogleInputs */



/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Login_GoogleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_google = /** @type {((inputs?: Login_GoogleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_GoogleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verder met Google")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer avec Google")
	return /** @type {LocalizedString} */ ("Continue with Google")
});